/* LUCY — interactions */
(() => {
  'use strict';
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const sleep = ms => new Promise(r => setTimeout(r, ms));

  /* Header background once scrolled */
  const header = $('[data-header]');
  const sticky = $('[data-sticky]');
  const pricing = $('#pricing');
  const onScroll = () => {
    const y = window.scrollY;
    header && header.classList.toggle('is-scrolled', y > 8);
    if (sticky) {
      let show = y > 700;
      if (pricing) { const r = pricing.getBoundingClientRect(); if (r.top < window.innerHeight && r.bottom > 0) show = false; }
      sticky.classList.toggle('is-on', show);
    }
  };
  window.addEventListener('scroll', onScroll, { passive: true }); onScroll();

  /* Mobile menu */
  const toggle = $('[data-menu-toggle]'), menu = $('[data-menu]');
  if (toggle && menu) {
    const set = open => { menu.hidden = !open; toggle.setAttribute('aria-expanded', String(open)); };
    toggle.addEventListener('click', () => set(menu.hidden));
    $$('a', menu).forEach(a => a.addEventListener('click', () => set(false)));
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && !menu.hidden) { set(false); toggle.focus(); } });
  }

  /* Tabs: click + arrow keys */
  function tabs(buttons, onPick) {
    if (!buttons.length) return;
    const pick = i => {
      buttons.forEach((x, k) => { const on = k === i; x.classList.toggle('is-on', on); x.setAttribute('aria-selected', String(on)); x.tabIndex = on ? 0 : -1; });
      onPick(buttons[i], i);
    };
    buttons.forEach((b, i) => {
      b.tabIndex = b.classList.contains('is-on') ? 0 : -1;
      b.addEventListener('click', () => pick(i));
      b.addEventListener('keydown', e => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft' && e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
        e.preventDefault();
        const dir = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : -1;
        const n = (i + dir + buttons.length) % buttons.length;
        buttons[n].focus(); pick(n);
      });
    });
  }

  /* ---------- Product tour (hero app) ---------- */
  const app = $('[data-app]'), dataEl = $('[data-app-data]');
  if (app && dataEl) {
    let data = {};
    try { data = JSON.parse(dataEl.textContent); } catch (e) { data = {}; }
    const out = $('[data-out]', app), crumb = $('[data-app-crumb]', app), kindLabel = $('[data-app-kind-label]', app), url = $('[data-app-url]', app), copyBtn = $('[data-copy]', app);
    let product = 'throw', kind = 'page', run = 0;

    const parse = text => {
      const blocks = []; let list = null; let afterTitle = false;
      text.split('\n').forEach(line => {
        if (line.startsWith('# ')) { list = null; blocks.push({ tag: 'h4', text: line.slice(2) }); afterTitle = true; return; }
        if (line.startsWith('## ')) { list = null; blocks.push({ tag: 'h5', text: line.slice(3) }); afterTitle = false; return; }
        if (line.startsWith('- ')) { if (!list) { list = { tag: 'ul', items: [] }; blocks.push(list); } list.items.push(line.slice(2)); return; }
        list = null;
        if (!line.trim()) { afterTitle = false; return; }
        blocks.push({ tag: afterTitle ? 'p.sub' : 'p', text: line }); afterTitle = false;
      });
      return blocks;
    };
    const build = blocks => {
      out.innerHTML = ''; const targets = [];
      blocks.forEach(b => {
        if (b.tag === 'ul') { const ul = document.createElement('ul'); b.items.forEach(t => { const li = document.createElement('li'); ul.appendChild(li); targets.push([li, t]); }); out.appendChild(ul); return; }
        const [tag, cls] = b.tag.split('.'); const el = document.createElement(tag); if (cls) el.className = cls;
        out.appendChild(el); targets.push([el, b.text]);
      });
      return targets;
    };
    async function render() {
      const my = ++run;
      const d = data[product] || {};
      crumb.textContent = d.name || ''; url.textContent = d.url || '';
      const tab = $('[data-kind].is-on', app); kindLabel.textContent = tab ? tab.textContent : '';
      const targets = build(parse(d[kind] || ''));
      if (reduced) { targets.forEach(([el, t]) => el.textContent = t); return; }
      const caret = document.createElement('span'); caret.className = 'caret';
      for (const [el, text] of targets) {
        el.appendChild(caret);
        const step = text.length > 80 ? 4 : 2;
        for (let i = 0; i < text.length; i += step) {
          if (my !== run) return;
          caret.before(text.slice(i, i + step));
          await sleep(el.tagName === 'H4' ? 24 : 12);
        }
      }
      if (my === run) setTimeout(() => caret.remove(), 1200);
    }
    tabs($$('[data-product]', app), b => { product = b.dataset.product; render(); });
    tabs($$('[data-kind]', app), b => { kind = b.dataset.kind; render(); });
    copyBtn && copyBtn.addEventListener('click', () => {
      const label = $('span', copyBtn);
      const done = () => { label.textContent = 'Copied'; setTimeout(() => { label.textContent = 'Copy'; }, 1500); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(out.innerText.trim()).then(done, () => {});
    });
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(([en]) => { if (en.isIntersecting) { io.disconnect(); render(); } }, { threshold: .2 });
      io.observe(app);
    } else render();
  }

  /* ---------- Brand voice switcher ---------- */
  $$('[data-voice]').forEach(v => {
    const panels = $$('[data-voice-panel]', v);
    tabs($$('[data-voice-pick]', v), (b, i) => panels.forEach((p, k) => p.classList.toggle('is-on', k === i)));
  });

  /* ---------- Plan picker ---------- */
  $$('[data-plans]').forEach(sec => {
    const panels = $$('[data-plan-panel]', sec);
    $$('[data-plan-radio]', sec).forEach(r => r.addEventListener('change', () => {
      panels.forEach(p => p.classList.toggle('is-on', p.dataset.planPanel === r.value));
    }));
  });
})();

/* Inner pages */
(() => {
  'use strict';
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  /* Use cases tabs */
  $$('[data-usecases]').forEach(sec => {
    const tabs = $$('[data-uc-tab]', sec), panels = $$('[data-uc-panel]', sec);
    const pick = i => {
      tabs.forEach((t, k) => { const on = k === i; t.classList.toggle('is-on', on); t.setAttribute('aria-selected', String(on)); t.tabIndex = on ? 0 : -1; });
      panels.forEach((p, k) => p.classList.toggle('is-on', k === i));
    };
    tabs.forEach((t, i) => {
      t.tabIndex = i === 0 ? 0 : -1;
      t.addEventListener('click', () => pick(i));
      t.addEventListener('keydown', e => {
        const keys = { ArrowDown: 1, ArrowRight: 1, ArrowUp: -1, ArrowLeft: -1 };
        if (!(e.key in keys)) return;
        e.preventDefault(); const n = (i + keys[e.key] + tabs.length) % tabs.length; tabs[n].focus(); pick(n);
      });
    });
  });
  /* Compare plans toggle */
  $$('[data-compare]').forEach(box => {
    const btn = box.querySelector('[data-compare-toggle]'), panel = box.querySelector('.compare__scroll');
    btn.addEventListener('click', () => { const open = btn.getAttribute('aria-expanded') !== 'true'; btn.setAttribute('aria-expanded', String(open)); panel.hidden = !open; box.classList.toggle('is-open', open); });
  });
  /* Open the comparison when a link points to it */
  $$('a[href$="#compare"]').forEach(a => a.addEventListener('click', () => { const b = document.querySelector('#compare [data-compare-toggle]'); if (b && b.getAttribute('aria-expanded') !== 'true') b.click(); }));
  /* Legal: highlight the clause you're reading */
  const links = $$('.legal__toc a');
  if (links.length && 'IntersectionObserver' in window) {
    const byId = new Map(links.map(a => [a.getAttribute('href').slice(1), a]));
    const io = new IntersectionObserver(entries => entries.forEach(en => {
      if (!en.isIntersecting) return;
      links.forEach(a => a.classList.remove('is-on'));
      const a = byId.get(en.target.id); a && a.classList.add('is-on');
    }), { rootMargin: '-25% 0px -65% 0px' });
    $$('.clause').forEach(c => io.observe(c));
  }
})();
